import { GALLERY_CONSTS, INPUT_TYPES } from '../utils/constants';
import { hasVerticalPlacement } from '../../common/constants/placements';
export default {
  title: 'Text Box Height (pixels)',
  description: "Set the text box Height when the texts are above or below the item",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.isVertical && styleParams.groupSize === 1 && !styleParams.oneRow && hasVerticalPlacement(styleParams.titlePlacement) && styleParams.calculateTextBoxHeightMode === GALLERY_CONSTS.textBoxHeightCalculationOptions.MANUAL && (styleParams.allowTitle || styleParams.allowDescription);
  },
  type: INPUT_TYPES.NUMBER,
  "default": 200,
  min: 0,
  max: 1000
};